import { FC } from 'react';
import React from 'react';
import { useEffect, useState } from 'react';

import { CloseOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import InputDescription from '../quiz-input-show-description/quiz-input-show-description';
import './MultipleTextBox.css';
import { useQuizFormContext } from '../../hooks/quiz-form-context';

const MultipleTextBox = ({
  title,
  name,
  size = 'large',
  Error,
  description,
  indexKey,
  allInputOnchageHandler,
  questionTooltip
}) => {
  const {
    formValues,
    contentFullErrorMsg,
    setContentFulErrorMsg,
    getInputValues,
    allFormErrorsList,
  } = useQuizFormContext();
  // Fetch data from local storage
  const tempObjVal = getInputValues(name, formValues);

  // Use local storage data or set default value (empty string)
  const initialMultipleInputVal = tempObjVal?.value || [''];

  const [multipleInputVal, setMultipleInputVal] = useState(initialMultipleInputVal);

  // Custom array comparison function
  const areArraysEqual = (arr1, arr2) => {
    return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
  };

  useEffect(() => {
    // If local storage data changes, update the state
    if (tempObjVal?.value && !areArraysEqual(tempObjVal?.value, multipleInputVal)) {
      setMultipleInputVal(tempObjVal?.value);
    }
  }, [tempObjVal]);

  //SHOWING QUESTION TITLE AND DESCRIPTION
  function ShowDescription(description) {
    return <InputDescription description={description} questionTooltip={questionTooltip} />;
  }

  function handleInputChange(e, index) {
    const { value } = e.target;
    const updatedValues = [...multipleInputVal];
    updatedValues[index] = value;
    setMultipleInputVal(updatedValues);
  }

  const removeField = (index) => {
    const updatedValues = [...multipleInputVal];
    updatedValues.splice(index, 1);
    setMultipleInputVal(updatedValues);
  };

  useEffect(() => {
    allInputOnchageHandler(indexKey, title, name, multipleInputVal);
  }, [multipleInputVal]);

  return (
    <div>
      <Form.List
        className="multiple-inputboc-container"
        name={`names-${indexKey}`}
        initialValue={initialMultipleInputVal}
        rules={
          [
            // {
            //   validator: async (_, names) => {
            //     if (!names || names.length < 1) {
            //       return Promise.reject(new Error('At least 1 passenger'));
            //     }
            //   },
            // },
          ]
        }
      >
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map((field, index) => {
                return (
                  <Form.Item
                    label={index === 0 ? description && ShowDescription(description) : ''}
                    required={Error ? true : false}
                    key={field.key}
                  >
                    <Form.Item
                      {...field}
                      validateTrigger={['onChange', 'onBlur']}
                      rules={
                        [
                          // {
                          //   required: true,
                          //   whitespace: true,
                          //   message: "Please input passenger's name or delete this field.",
                          // },
                        ]
                      }
                      noStyle
                    >
                      <Input
                        size={size}
                        name={`${name}-${index}`}
                        onChange={(e) => handleInputChange(e, index)}
                        className={fields.length > 1 ? 'multiple-input-text' : 'input-text'}
                        defaultValue={multipleInputVal[index]}
                      />
                    </Form.Item>
                    {/* {allFormErrorsList[name] && <span className="error-message">{Error}</span>} */}
                    {fields.length > 1 ? (
                      <Button
                        className="multiple-input remove-button"
                        type="text"
                        onClick={() => {
                          removeField(index);
                          remove(field.name);
                        }}
                      >
                        <span>
                          <CloseOutlined />
                        </span>{' '}
                        Remove
                      </Button>
                    ) : null}
                  </Form.Item>
                );
              })}

              <Button
                type="dashed"
                className="multiple-input add-button"
                onClick={() => add()}
                icon={<PlusOutlined />}
              >
                Add Location
              </Button>
            </>
          );
        }}
      </Form.List>
    </div>
  );
};

export default MultipleTextBox;
